import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/circleci/project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/modules/layouts/components/Layout/Layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/about/components/Nav.module.css");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/src/features/about/components/PageContent.module.css");
